import { Box } from "@mui/material";

const SD_COIN_IMAGE = "/assets/images/SD_coin.png";

export default function SDCoinIcon({ size = 18, sx = {}, alt = "SD Coin" }) {
  return (
    <Box
      component="img"
      src={SD_COIN_IMAGE}
      alt={alt}
      sx={{
        width: size,
        height: size,
        objectFit: "contain",
        verticalAlign: "middle",
        display: "inline-block",
        flexShrink: 0,
        ...sx,
      }}
    />
  );
}
